import { startPostHogSessionRecording } from "@client/telemetry/posthog";
import { runWhenStartupSettled } from "./idle";

// PostHog lazily fetches and initializes its session recorder
// (`posthog-recorder.js`, ~166KB) the moment recording starts. Starting it
// during `posthog.init()` puts ~50ms of script work on the critical load
// path, and starting it merely "when idle" landed it there anyway — idle
// windows right after startup sit between the fetches and mounts the user is
// waiting on. We instead init with `disable_session_recording: true` and call
// this behind the startup-settled gate (`load` + grace period + idle; see
// `runWhenStartupSettled`). The trade-off is that the first few seconds of
// the session aren't captured — acceptable for the load-time win.
export function startSessionRecordingWhenStartupSettled() {
  runWhenStartupSettled(startPostHogSessionRecording);
}
